import { default as React, useEffect } from 'react';
import Contact from './Contact';
import Form from './Form';

import { useLocation } from 'react-router-dom';

const Footer = () => {
	const { hash } = useLocation();

	useEffect(() => {
		if (hash) {
			const target = document.querySelector(hash);
			if (target) {
				const yOffset = 100; // Offset for fixed navbar
				const yPosition =
					target.getBoundingClientRect().top +
					window.scrollY +
					yOffset;
				window.scrollTo({ top: yPosition, behavior: 'smooth' });
			}
		}
	}, [hash]);
	return (
		<footer class='bg-[#87152B] md:bg-transparent text-center h-auto  lg:text-left flex flex-col items-center justify-center'>
			<div className='flex bg-[#87152B] flex-col lg:flex-row items-center justify-center gap-2 w-[80%]  lg:w-[80%] py-2 md:px-16'>
				<Contact />
				<Form />
			</div>
			<div class='p-4 text-center text-surface text-white w-[80%] bg-[#87152B]'>
				© 2024 Copyright : <span>CFCAE</span>
			</div>
		</footer>
	);
};

export default Footer;
